import React from "react";
import Nav from "./Components/Nav/Nav"
import Home from "./Components/Home/Home"
import Work from "./Components/Work/Work";
import Skills from "./Components/Skills/skills";
import Contact from "./Components/Contact/contact"
import Footer from "./Components/Footer/Footer";
import WorkedCompanies from "./Components/workedCompanies/workedCompanies";
import Advocacy from "./Components/Advocacy/Advocacy";
import SocialBar from "./Components/SocialBar/SocialBar";
import "./App.css";

const App = () => {
  return (
    <>
    <div className="max-w-7xl mx-auto">
      <Nav />
      <Home />
      <Work />
      <WorkedCompanies />
      <Skills />
      <Advocacy />
      <Contact />
    </div>
    <div className="max-w-full mx-auto">
      <Footer />
    </div>
    <SocialBar />
    </>
  );
}

export default App;
